export default "/_next/static/images/0b7969b9be42fce4c67553ba140cdc61.jpg";